import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Fade from "@mui/material/Fade";
import { Box, Typography, styled } from "@mui/material";
import Button from "../../../components/Button";
import CustomTextField from "../../../components/Textfield";
import { getSx } from "../../../components/Modal/style";
import { useDispatch } from "react-redux";
import Spinner from "../../../components/Spinner";
import CustomTextArea from "../../../components/Textarea";
import { sendReply } from "../../../http/auth";
import { showToast } from "../../../store/slices/common";
import DownloadIcon from "@mui/icons-material/Download";
import { Collapse, Steps } from "antd";
import dayjs from "dayjs";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Fade ref={ref} {...props} />;
});

const CustomDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    width: "600px",
    padding: "30px",
    borderRadius: "20px",
    "&::-webkit-scrollbar": {
      width: "0px",
      background: "transparent",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "transparent",
    },
  },
  "& .MuiPaper-root": { maxWidth: "400px" },
  "& .MuiDialogActions-root": {},
}));

export default function EditHelpnSupport({
  open,
  setOpen,
  supportData,
  getHelpNSupport,
}) {
  const [loading, setLoading] = useState(false);
  const [reply, setReply] = useState("");
  const classes = getSx(true);
  const dispatch = useDispatch();

  const closeModalHandler = () => {
    setOpen(false);
  };

  const sendReplyHandler = async () => {
    try {
      setLoading(true);
      const payload = { reply: reply, supportId: supportData?._id };
      const res = await sendReply(payload);
      await getHelpNSupport();
      dispatch(showToast({ color: "success", msg: res.data.message?.en }));
      closeModalHandler();
      setLoading(false);
    } catch (err) {
      setLoading(false);
      // dispatch(showToast({ color: "error", msg: "Something went wrong" }));
    }
  };

  const handleDownload = (url) => {
    const a = document.createElement("a");
    a.href = url;
    a.download = url.split("/").pop(); // Use the file name from URL
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <CustomDialog
      open={open}
      keepMounted
      onClose={() => setOpen(false)}
      TransitionComponent={Transition}
      sx={{
        "& .MuiPaper-root": {
          maxWidth: "600px",
          paddingLeft: 0,
          paddingRight: 0,
        },
      }}
    >
      {loading && <Spinner />}
      <form>
        <DialogContent sx={{ padding: "8px 35px" }}>
          <Typography
            sx={{
              fontSize: "20px",
              minWidth: "300px",
              textAlign: "center",
            }}
          >
            Help and Support
          </Typography>
          <form>
            <Typography
              className="header"
              color="#687F89"
              width="100%"
              fontWeight="400"
              fontSize="16px"
            >
              Name
            </Typography>
            <Box
              borderRadius="40px"
              display="flex"
              width="100%"
              flexDirection="column"
              justifyContent="center"
            >
              <CustomTextField
                type="text"
                name="name"
                placeholder="Name"
                value={supportData?.name}
                disabled={true}
              />
            </Box>
            <Typography
              className="header"
              color="#687F89"
              width="100%"
              fontWeight="400"
              fontSize="16px"
              marginTop="15px"
            >
              Email
            </Typography>
            <Box
              borderRadius="40px"
              display="flex"
              width="100%"
              flexDirection="column"
              justifyContent="center"
            >
              <CustomTextField
                type="text"
                name="email"
                placeholder="Email"
                value={supportData?.email}
                disabled={true}
              />
            </Box>
            <Typography
              className="header"
              color="#687F89"
              width="100%"
              fontWeight="400"
              fontSize="16px"
              marginTop="15px"
            >
              Description
            </Typography>
            <Box
              borderRadius="40px"
              display="flex"
              width="100%"
              flexDirection="column"
              justifyContent="center"
            >
              <CustomTextArea
                type="text"
                name="answer"
                from="faq"
                placeholder="Help and Support"
                value={supportData?.description}
                disabled={true}
              />
            </Box>
            {supportData.attachments && (
              <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <Typography
                  className="header"
                  color="#687F89"
                  fontWeight="400"
                  fontSize="16px"
                  marginTop="10px"
                >
                  Attachments
                </Typography>
                <DownloadIcon
                  onClick={() => handleDownload(supportData.attachments)}
                  sx={{ marginTop: "15px", cursor: "pointer", color: "blue" }}
                />
              </Box>
            )}
            {supportData?.reply?.length > 0 && (
              <Collapse
                style={{ marginTop: "12px" }}
                className="past-reply"
                items={[
                  {
                    key: "1",
                    label: "See past reply",
                    children: (
                      <Steps
                        current={-1}
                        direction="vertical"
                        items={supportData?.reply.map((i) => ({
                          title: dayjs(i.repliedAt).format("YYYY-MM-DD HH:mm"),
                          description: i.replies,
                        }))}
                      />
                    ),
                  },
                ]}
              />
            )}
            <Typography
              className="header"
              color="#687F89"
              width="100%"
              fontWeight="400"
              fontSize="16px"
              marginTop="10px"
            >
              Reply
            </Typography>
            <Box
              borderRadius="40px"
              display="flex"
              width="100%"
              flexDirection="column"
              justifyContent="center"
            >
              <CustomTextArea
                type="text"
                name="reply"
                from="faq"
                placeholder="Enter the Answer"
                value={reply}
                onChange={(e) => setReply(e.target.value)}
              />
            </Box>
            <DialogActions
              disableSpacing={false}
              sx={{
                ...classes.buttonWrapper,
                justifyContent: "center",
                marginTop: "20px",
              }}
            >
              <Button
                style={{
                  marginTop: 0,
                  width: "50%",
                  minWidth: "150px",
                  maxWidth: "150px",
                }}
                className="theme-btn-contained theme-btn theme-auth-btn"
                label="Send"
                variant="contained"
                color="primary"
                disabled={supportData.reply === reply}
                onClick={sendReplyHandler}
              />
              <Button
                style={{
                  marginTop: 0,
                  width: "50%",
                  minWidth: "150px",
                  maxWidth: "150px",
                }}
                className="theme-btn-contained theme-btn theme-auth-btn"
                label="Cancel"
                variant="contained"
                color="primary"
                onClick={closeModalHandler}
              />
            </DialogActions>
          </form>
        </DialogContent>
      </form>
    </CustomDialog>
  );
}
